import type { WorksiteFilter, WorksiteWithAccountsCount } from 'api/modules/worksites/api';
import { generateManyWorksiteFilters, generateManyWorksites } from './fakers';

/**
 * 100 fake worksites for testing infinite scroll in filter dropdowns
 */
export const fakeWorksiteFilters: WorksiteFilter[] = generateManyWorksiteFilters(100);

/**
 * 25 fake worksites with full details for testing worksite list views
 */
export const fakeWorksites: WorksiteWithAccountsCount[] = generateManyWorksites(25);